import {
  ChangeDetectionStrategy,
  Component,
  effect,
  ElementRef,
  inject,
  input,
} from "@angular/core";

/**
 * This component is used to render a simple skeleton.
 * 
 * The componnent is based on and fully compatible with the skeleton component
 * of PrimeNG. If and when the design system is implemented, all instances of
 * app-skeleton can simply be replaced with p-skeleton.
 */
@Component({
  selector: "app-skeleton",
  template: "",
  styleUrl: "./skeleton.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SkeletonComponent {
  elementReference: ElementRef<HTMLElement> = inject(ElementRef);

  width = input<string>();

  constructor() {
    const nativeElement = this.elementReference.nativeElement;
    effect(() => {
      nativeElement.style.maxWidth = this.width() || "";
    });
  }
}
